import * as Yup from "yup";

export const newTicketValidationSchema = Yup.object().shape({
  title: Yup.string().required("Le titre est requis"),
});
